export default {_name:'field.code',module:'Field',view:'Element/Field/Code',options:{events:{onChange:'persistChange'},helperText:' ',xs:12}}